import { Auth } from 'aws-amplify';

export const getAuthData = async () => {
  try {
    const session = await Auth.currentSession();
    const idToken = session.getIdToken();
    const jwtToken = idToken.getJwtToken();

    return {
      session,
      idToken,
      jwtToken,
    };
  } catch (error) {
    throw new Error(error);
  }
};
